var commitDate = "20200722";
jQuery(function(){
	//2022-07-13 빅배너 롤링 텍스트 컬러
	var visualSlider = $(".visual_slider");
	var visualMain = document.querySelector('.shop_template');
	
	function visualChange(el){
		var currentBg = el.querySelector('.slide_item').dataset.bg;
		visualMain.dataset.bg = currentBg ;
		}
	
	visualSlider.on('init', function (event, slick) {
		visualChange( slick.$slides[slick.currentSlide] );
	});
	
	visualSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		infinite: true,
		cssEase: 'linear',
		autoplaySpeed: 4000,
		autoplay : true,
		fade: true,
		adaptiveHeight : true,
		prevArrow: '<button type="button" class="slick_prev">Prev</button>',
		nextArrow: '<button type="button" class="slick_next">Next</button>',
		dotsClass: 'slick_paging',
	});


	function clickNewProductMoreBtn() {
		// 신상품 더보기
		$('#new-prd').off('click', '.link-text').on('click', '.link-text', function() {
			var sectId = $(this).data('category');
			var lseq = $(this).data('lseq');
			var jbpBrandCd = $('#shop_premium_wrap').data('brandcd');
			if (!sectId || !lseq || !jbpBrandCd) return;
			var array = String(sectId).split('_');
			var category = array[array.length - 1];
			var linkUrl = "/shop/jbp/signatureJbp/sect.gs?jbpBrandCd="+jbpBrandCd+"&sectId="+category+"&lseq="+lseq;
			location.href = linkUrl;
		});
	}
	// 신상품 더보기
	clickNewProductMoreBtn();
	
//	if($(".slick_paging").length == 0){
//		$(".shop_visual_wrap").css("margin-bottom", "50px");
//	}

	$(window).on('resize orientationchange', function() {
		visualSlider.slick('resize');
	});
	
	visualSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
		console.log('@before', currentSlide, nextSlide);
		visualChange( slick.$slides[nextSlide] );
	});

	jQuery('[data-swipe="new-arrivals"]').gsSwiper({
		autoplay:false,
		speed:500,
		slideIS:true,
		loop: true,
		//resizeIS: true,
		maxPositionSet: false,
		slidesPerView: 2,
		calculateHeight: true,
		//slidesPerGroup	: 1,
		prevClass: 'new_prev',
		nextClass: 'new_next'
	});
	
	// 추천딜 스와프 추가 2022-06-29 
	$('[data-swipe=swiper3]').gsSwiper({ 
		loop: true,
		autoplay: false, 
		speed: 500, 
//		slidesPerGroup: 3,
		slidesPerView: 3,
		slideIS: true, 
		resizeIS :true, 
		prevClass: 'new_prev',
		nextClass: 'new_next',
	});

	// 신상품
	var planSlides = jQuery('[data-swipe=plan-swiper]').find('.swiper-slide').length;
	if (planSlides > 3) {
		jQuery('[data-swipe=plan-swiper]').gsSwiper({
			autoplay:false,
			speed:500,
			loop: true,
			//resizeIS: true,
			// slidesPerView: 'auto',
			slidesPerView: 3,
			calculateHeight: true,
			//slidesPerGroup	: 1,
			prevClass: 'new_prev',
			nextClass: 'new_next',
		});
	} else {
		// 스와이퍼 미실행, 네비게이션 숨김
		jQuery('.item-module.plan-bnr').find('.shop_swiper_nav').hide();
	}

	// 브랜드스토리
	var newCollectionSlides = jQuery('[data-swipe="story-swiper"]').find('.swiper-slide');
	if (newCollectionSlides.length > 3) {
		jQuery('[data-swipe=story-swiper]').gsSwiper({
			autoplay: false,
			speed: 500,
			loop: true,
			//resizeIS: true,
			slidesPerView: 3,
			calculateHeight: true,
			//slidesPerGroup	: 1,
			prevClass: 'new_prev',
			nextClass: 'new_next',
		});
	}

	// 메인 빅배너 스와이프
	var newCollectionSlides = jQuery('[data-swipe="new-collection"]').find('.swiper-slide');
	if (newCollectionSlides.length > 1) {
		jQuery('[data-swipe="new-collection"]').gsSwiper({
			autoplay:0,
			slideIS:true,
			resizeIS: true,
			speed:300,
			touch: false,
			slidesPerView: 1,
			calculateHeight: true,
			clicked:false,
			maxPositionSet: false,
			onInit: function(swiper) {
				var color = jQuery(swiper.slides[swiper.activeIndex]).data('bg');
				updateBannerColor(color);
			},
			onChangeStart: function(swiper) {
				var color = jQuery(swiper.slides[swiper.activeIndex]).data('bg');
				updateBannerColor(color);
			}
		});
	} else {
		updateBannerColor(newCollectionSlides.first().data('bg'));
	}

	function updateBannerColor(color) {
		// color = 'white' or 'black'
		visualMain.dataset.bg = color ;
	}


	var jcaro = jQuery(".preview_box .thumb_gallery ul li");

	jQuery(".preview_box .thumb_gallery").jCarouselLite({
		btnNext: ".thumbnamil_box .next",
		btnPrev: ".thumbnamil_box .prev",
		circular: true,
		visible: 5,
		speed: 500
	});

	jcaro.each(function(){
		if(jcaro.length < 5){
			jQuery(".thumbnamil_box .prev, .thumbnamil_box .next").off("click").css("display", "none");
			jQuery(".preview_box .thumb_gallery_wrap").css({"text-align" : "center"});
			jQuery(".preview_box .thumb_gallery").css("display", "inline-block");
			jQuery(".preview_box .thumb_gallery").width("auto");
		}else if(jcaro.length > 5){
			jQuery(".thumb_gallery_wrap").css("padding-left", "20px");
			jQuery(".thumbnamil_box .prev, .thumbnamil_box .next").css("display", "block");
			jQuery(".preview_box .thumb_gallery").css("display", "block");
			jQuery(".preview_box .thumb_gallery").width("500px");
			//jQuery(".preview_box .thumb_gallery").css("margin-left", "20px");
		}
		if(jcaro.length == 5){
			jQuery(".thumb_gallery_wrap").css("padding-left", "20px");
			jQuery(".preview_box .thumb_gallery").css("display", "block");
			jQuery(".thumbnamil_box .prev, .thumbnamil_box .next").css("display", "none");
			//jQuery(".preview_box .thumb_gallery").css("margin-left", "20px");
		}
		if(jcaro.length == 4){
			jQuery(".preview_box .thumb_gallery").width("400px");
			jQuery(".preview_box .thumb_gallery ul").css("left", "-505px");
		}else if(jcaro.length == 3){
			jQuery(".preview_box .thumb_gallery").width("300px");
			jQuery(".preview_box .thumb_gallery ul").css("left", "-505px");
		}else if(jcaro.length == 2){
			jQuery(".preview_box .thumb_gallery").width("210px");
			jQuery(".preview_box .thumb_gallery ul").css("left", "-400px");
		}else if(jcaro.length == 1){
			jQuery(".thumb_gallery_wrap").css("padding-left", "10px");
			jQuery(".preview_box .thumb_gallery").width("100px");
			jQuery(".preview_box .thumb_gallery ul").css("left", "-10px");
		}
	});

	var thumbGallery = jQuery(".thumb_gallery ul li img");
	thumbGallery.hover(function(){
		jQuery('.zoomContainer').remove();
		var _html = "";
		if(jQuery(this).hasClass('zoom')) {
			 //_html += '<img src="" id="view_zoom" alt="" />';
			//jQuery(".view_box").empty().append(_html);
			jQuery(".view_box img").attr("src", jQuery(this).attr("data-src"));
			jQuery(".view_box img").attr("data-zoom-image", jQuery(this).attr("data-zoom-image"));
			jQuery(".view_box img").attr("alt", jQuery(this).attr("alt"));
			jQuery(".zoom_desc span").css('display', '');
			elevateZoom();
		} else {
			//_html = '<img src="" alt="" />';
			//jQuery(".view_box").empty().append(_html);
			jQuery(".view_box img").attr("src", jQuery(this).attr("data-src"));
			jQuery(".view_box img").attr("alt", jQuery(this).attr("alt"));
			jQuery(".zoom_desc span").css('display', 'none');
		}
		//jQuery(".view_box img").attr("src", jQuery(this).attr("data-src"));
		jQuery(this).parent().addClass("on").siblings().removeClass("on");
	}, function(){
		jQuery(this).parent().removeClass("on");
	});
	if(jQuery(".thumb_gallery ul li img").eq(0).hasClass('zoom')) {
		elevateZoom();
	}

	function elevateZoom() {
		jQuery("#view_zoom").elevateZoom({
			tint: false,
			lensOpacity: 0.4,
			//lensColour: "#fff",
			lensBorderSize: 1,
			lensBorderColour: "#000",
			lensSize: 150,
			borderSize: 0,
			zoomWindowWidth: 510,
			zoomWindowHeight: 508,
			cursor: "crosshair"
			//tintColour: '#f90',
			//tintOpacity: 0.5
		});
	}

	function img_hover(){
		jQuery(".img_replace>ul>li").each(function(){
			var repImg = jQuery(".img_replace>ul>li>a");
			var repImg_idx = repImg.find("img");
			var length = repImg_idx.length;
			repImg.find(".off").addClass("active");
			if(jQuery(">a>img", this).length != 1){
				repImg.hover(function(){
					jQuery(this).find(".on").addClass("active");
					jQuery(this).find(".off").removeClass("active");
					jQuery(this).find(".off:last-child").addClass("active");
				}, function(){
					jQuery(this).find(".on").removeClass("active");
					jQuery(this).find(".off").addClass("active");
				});
			}
		});
	}
	
	var imgReplace = jQuery(".img_replace>ul>li");
	imgReplace.each(function(){
		var repImg = jQuery(".img_replace>ul>li>a");
		var repImg_idx = repImg.find("img");
		var length = repImg_idx.length;
		repImg.find(".off").addClass("active");
		if(jQuery(">a>img", this).length != 1){
			repImg.hover(function(){
				jQuery(this).find(".on").addClass("active");
				jQuery(this).find(".off").removeClass("active");
				jQuery(this).find(".off:last-child").addClass("active");
			}, function(){
				jQuery(this).find(".on").removeClass("active");
				jQuery(this).find(".off").addClass("active");
			});
		}
	});

	var imgreplGroup = jQuery(".item_group");
	imgreplGroup.each(function(){
		var repImg = jQuery(".item_box>a");
		var repImg_idx = repImg.find("img");
		var length = repImg_idx.length;
		repImg.find(".off").addClass("active");
		if(jQuery("img", this).length != 1){
			repImg.hover(function(){
				jQuery(this).find(".on").addClass("active");
				jQuery(this).find(".off").removeClass("active");
				jQuery(this).find(".off:last-child").addClass("active");
			}, function(){
				jQuery(this).find(".on").removeClass("active");
				jQuery(this).find(".off").addClass("active");
			});
		}
	});
	

	// PC '공유하기 레이어'와 '찜 ON 상태' 화면이 추가
	jQuery("#btn_layer_share").click(function(e){
		var _id = jQuery(this).attr("href");
		var _top = jQuery(this).offset().top;
		var _left = jQuery(this).offset().left;
		jQuery(this).toggleClass('on');
		if(jQuery("#btn_layer_share").hasClass('on')) {
			jQuery(_id).css({'top':_top, 'left':_left, 'display':'block'});
		} else {
			jQuery(_id).hide();
		}
		return false;
	});
	jQuery(".btn_shop_close").click(function(){
		jQuery(".shop_top_banner").hide();
		return false;
	});
	jQuery(".btn_layer_close").click(function(){
		jQuery(".layerpop_premium").hide();
		return false;
	});

	/* 2020-03-24 삭제
	if(jQuery(".shop_gnb.d2>ul>li").length < 6){
		jQuery(".shop_gnb.d2>ul>li").css("width", "200px");
	}else{
		jQuery(".shop_gnb.d2>ul>li").css("width", "160px");
		jQuery(".shop_gnb.d2>ul>li").css("width", "");
	}
	*/

	var d2LiCnt,dep2Height;
	var dLiCnt = 0;
	var depHeight = 250;
	var tmp,_left,_outerWidth;
	
	// 더보기 숨김처리
	function checkPosition() {
		if (window.matchMedia('(min-width: 1400px)').matches) {
			if(1158 <= jQuery("#shopPreGnb ul").outerWidth()) {
				jQuery("#btnTrigger").show();
			} else {
				jQuery("#btnTrigger").hide();
			}
		} else {
			if(900 <= jQuery("#shopPreGnb ul").outerWidth()) {
				jQuery("#btnTrigger").show();
			} else {
				jQuery("#btnTrigger").hide();
			}
		}
	}
	$(document).load($(window).bind("load resize", checkPosition));

	// 더보기 텍스트 변경
	jQuery("#btnTrigger").on("click", function(e) {
		jQuery(this).parents("nav.shop_gnb").toggleClass("fold");
		e.preventDefault();
		if(jQuery(this).parents("nav.shop_gnb").hasClass("fold")) {
			jQuery(this).find("span").text("더보기");
		} else {
			jQuery(this).find("span").text("닫기");
		}
	});

	jQuery(".shop_gnb").on({"mouseleave" : function(){
		//jQuery("#subDepWrp").css("height", 0).hide();
        jQuery("#subDepWrp").hide();
		jQuery(this).find(">ul>li").removeClass("on");
	}});

	jQuery(".shop_gnb>ul>li").each(function(){
		
		jQuery(this).on({"mouseenter focusin" : function(){
			// 2022-02-04 추가 시작
			$("#subDepWrp > .nav2_dep > li").removeClass("on");
			// 2022-02-04 추가 끝

			if(jQuery(this).find("a").hasClass("has_sub_dep")) {
				tmp = jQuery(this).find(".has_sub_dep").position().top + 58;
				jQuery("#subDepWrp").css("top", tmp);

				if(jQuery("#subDepWrp").hasClass("has_nav3_dep") == true) {
					_left = jQuery(this).find(".has_sub_dep").position().left;
					_outerWidth = jQuery(this).outerWidth();

					jQuery("#subDepWrp").find(".arrow").css({"left":_left,"margin-left": _outerWidth / 2});
				}

                var lCateId = $(this).children().data('sectid');

                $('#subDepWrp > .nav2_dep > li').each(function(){
                    var mParentId = $(this).children().data('parentid');

                    if(lCateId != mParentId){
                        $(this).hide();
                    }else{
                        $(this).show();
                    }
                });

                jQuery("#subDepWrp").show();


				jQuery(this).addClass("on").siblings().removeClass("on");

                if(jQuery("#subDepWrp").hasClass("has_nav3_dep") == false) {
                    tmp = jQuery(this).outerWidth() / 2;
                    _left = jQuery(this).find(".has_sub_dep").position().left + tmp ;
                    _outerWidth = jQuery("#subDepWrp").outerWidth() * -1;
                    jQuery("#subDepWrp").css({"left": _left, "margin-left" : _outerWidth / 2});
                }
			} else {
                jQuery("#subDepWrp").hide();
				jQuery(this).addClass("on").siblings().removeClass("on");
			}
		}, "mouseleave" : function(){
		}});
		
		// 2022-02-04 추가 시작
		if(jQuery("#subDepWrp").hasClass("has_nav3_dep") == true) {
			jQuery(".shop_gnb .nav2_dep>li").on({"mouseenter focusin" : function(){
				depHeight = jQuery(this).find(".nav3_dep>li").length * 37;
				console.log(depHeight, 330 < depHeight);
				if(330 < depHeight) {
					jQuery("#subDepWrp").css("height", ( depHeight + 21) + "px");
				} else {
					jQuery("#subDepWrp").css("height", 330 + "px");
				}

				jQuery(this).addClass("on").siblings().removeClass("on");
			}, "mouseleave" : function(){
				jQuery("#subDepWrp").css("height", "auto");
			}});
		}
		// 2022-02-04 추가 끝

		// 3depth -default class setting
		jQuery(".nav2_dep").each(function (){jQuery(this).find("li:eq(0)").addClass("on")});
	});

	if(jQuery(".shop_gnb").css("display")=="block"){
		jQuery(".shop_nav_wrap").find(".shop_btn").show();
	}

	jQuery(".snb>ul>li").on("click", function(e){
		jQuery(this).addClass("on").siblings().removeClass("on");
		if(jQuery(this).hasClass("on")){
			jQuery(this).find(".depth").addClass("on");
		}else{
			jQuery(this).find(".depth").removeClass("on");
		}
		e.preventDefault();
	});

	jQuery(".snb .depth>ul>li").on("click", function(e){
		jQuery(this).addClass("on").siblings().removeClass("on");
		e.preventDefault();
	});

	var tabs = jQuery(".product_info .info_list>ul>li");
	tabs.first().addClass("on");
	tabs.each(function(){
		tabs.on({"click focus" : function(e){
			jQuery(this).addClass("on").siblings().removeClass("on")
			jQuery(this).find(".info_item").focus().attr("tabindex", 0);
			e.preventDefault();
		}});
	});
	var boxHeight = jQuery(".product_info .info_list").height();
	jQuery(".product_info .info_item").css("height", boxHeight);

	jQuery(".sorting_list>ul>li").on("click", function(e){
		jQuery(this).addClass("on").siblings().removeClass("on")
		e.preventDefault();
	});

	jQuery(".btn_card_benefit").click(function(){
		var idx = jQuery(this).attr("href");
		var el = jQuery(".layer_benefit_box");
		if(jQuery(idx).css("display")=="none"){
			jQuery(idx).show();
			jQuery(idx).parent().siblings(".btn_wrap").children("div.layer_benefit_box").hide();
			jQuery(this).addClass("on").parent().siblings(".btn_wrap").find(".btn_card_benefit").removeClass("on");
		}else{
			jQuery(idx).hide();
			jQuery(this).removeClass("on");
		}
		jQuery(".btn_benefit_close").click(function(){
			jQuery(idx).hide();
			jQuery(this).parent().parent().prev().removeClass("on");
			return false;
		});
		/*jQuery("html, body").click(function(){
			jQuery(idx).hide();
			jQuery(".btn_card_benefit").removeClass("on");
			return false;
		});*/
		return false;
	});
	if(jQuery(".btn_discount_box .btn_wrap").length  > 2){
		jQuery(".btn_discount_box").addClass("on");
		jQuery(".layer_benefit_box").addClass("on");
	}else{
		jQuery(".btn_discount_box").removeClass("on");
		jQuery(".layer_benefit_box").removeClass("on");
	}

	/*var img = jQuery(".elastislide-list>li");
	var current_data = jQueryimg.data("preview");
	img.click(function(){
		img.addClass("on").siblings().removeClass("on");
		return false;
	});
	img.each(function(){
		jQuery(".image_zoom").focus(function(){
			jQuery(".image_zoom").attr("href", jQuerycurrent_data);
		});
	});*/

	/*var elemHeight = jQuery(".layerpop_faq_list").height();
	if(jQuery(".layerpop_faq_list>ol>li").length > 9){
		jQuery("#layer_faq .layerpop_section").addClass("scroll").css("height", "506px");
	}else{
		jQuery("#layer_faq .layerpop_section").removeClass("scroll").css("height", "auto");
	}*/

	jQuery("#layer_faq .layerpop_section").addClass("scroll");
	jQuery(".layerpop_faq_list>ol>li").each(function(){
		jQuery(this).find(">a").click(function(e){
			if(jQuery(this).parent().toggleClass("on")== true){
				jQuery(this).parent().css("text-decoration", "underline").addClass("on");
			}else{
				jQuery(this).parent().siblings().removeClass("on");
			}
			e.preventDefault();
		});
	});

	jQuery(".layerpop").click(function(e){
		var id = jQuery(this).attr("href");
		var maskHeight = jQuery(document).height();
		var maskWidth = jQuery(window).width();
		var winH = jQuery(window).height();
		var winW = jQuery(window).width();

		jQuery(id).appendTo(jQuery("body"));
		jQuery("body").css("position", "relative");
		var top = ( jQuery(window).scrollTop() + (winH - jQuery(id).height()) / 2 );
		var left = ( jQuery(window).scrollLeft() + (winW - jQuery(id).width()) / 2 );

		jQuery(id).css({"top": "180px", "left": left});
		if(jQuery(id).height()>winH) jQuery(id).css({"top":jQuery(window).scrollTop()});
		//if(jQuery(id).height()<winH) jQuery(window).on('touchmove', function(e){e.preventDefault()});
		jQuery(id).fadeIn(300);
		jQuery(id).focus().attr("tabindex", 0);
		jQuery("body").append("<div id='layermask'></div>");
		//jQuery("#layermask").css({"width": maskWidth, "height": maskHeight});
		jQuery("#layermask").fadeTo("", 0.5);
		jQuery("#layermask").show();
		e.preventDefault();
	});
	jQuery(".shop_layer_close, #layermask").click(function(e){
		jQuery(window).off("touchmove");
		jQuery(".shop_layerpop").fadeOut(60);
		jQuery("#layermask").remove();
		e.preventDefault();
	});

	// jQuery(".shop_layerpop").blur(function(){
	// 	jQuery(".shop_layerpop").fadeOut(100);
	// 	jQuery("#layermask").remove();
	// });

	var winWidth = jQuery(window).width();
	jQuery(".thumb_item .thumb").hide();
	if(winWidth <= 1257){
		jQuery(".shop_feature.resizing").css({"padding-top" : "54px", "border-top" : "1px solid #d9d9d9"});
		jQuery(".thumb_item .thumb:lt(4)").show();
	}else if(winWidth >= 1258){
		jQuery(".thumb_item .thumb").show();
	}else{

	}

	var this_img = jQuery(".shop_template .temp_thumb a, .shop_template_wide .temp_thumb a");
	this_img.hover(function(){
		var img_box = jQuery(this).find(".desc");
		var img_img = jQuery(this).find(".desc_img");
		img_box.fadeIn().stop().animate({ "opacity": 1 }, 500);
		img_img.animate({"margin-top": "-14px"}, 500);
		jQuery.when(img_box, img_img).then();
		if(jQuery(this).find(".desc").children("img").length != 1){
			jQuery(this).children("img").css({"transition" : "all 0s ease 0s;", "transform" : "none", "opacity" : 1});
			jQuery(this).find(".desc").css({"display" : "none"});
		}
	}, function(){
		var img_box = jQuery(this).find(".desc");
		var img_img = jQuery(this).find(".desc_img");
		img_box.fadeOut().stop().animate({ "opacity": 0 }, 500);
		img_img.animate({"margin-top": 0}, 500);
		jQuery.when(img_box, img_img).then();
	});

	var isMobile = /ipad|ipod/i.test(navigator.userAgent.toLowerCase()) ? true : false;
	var isiPad = navigator.userAgent.toLowerCase().indexOf("ipad");
	var isiPod = navigator.userAgent.toLowerCase().indexOf("ipod");
	var filter = "win16|win32|win64|macintel|mac|";

	if( navigator.platform){
		if( filter.indexOf(navigator.platform.toLowerCase()) < 0){
			if(isiPad > -1 || isiPod > -1){
				this_img.off("mouseenter mouseleave");
				var img_box = jQuery(this).find(".desc");
				img_box.css("display", "none !important");
				jQuery(".shop_template .temp_thumb a>img, .shop_template_wide .temp_thumb a>img").css({"transition" : "all 0s ease 0s;", "transform" : "none", "opacity" : 1});
			}
			if(isMobile == true){
				this_img.off("mouseenter mouseleave");
				var img_box = jQuery(this).find(".desc");
				img_box.css("display", "none !important");
				jQuery(".shop_template .temp_thumb a>img, .shop_template_wide .temp_thumb a>img").css({"transition" : "all 0s ease 0s;", "transform" : "none", "opacity" : 1});
			}
		}else{

		}
	}

	//2022-04-07 OnecolumnBanner 오버효과 추가
	$('.single [data-swipe="ban-list2"]').each(function() {
		var oneColumnBnr = $('.single [data-swipe="ban-list2"] .swiper-slide').length;
		if (oneColumnBnr > 1) {
			$('[data-swipe="ban-list2"] .swiper-slide a').find('.desc').hide();
		}else{
			var this_img = $('.single [data-swipe="ban-list2"] .swiper-slide a');
			this_img.hover(function(){
				var img_box = $(this).find(".desc");
				img_box.fadeIn().stop().animate({ "opacity": 1 }, 500);
				$.when(img_box).then();
				if($(this).find(".desc").children("img").length != 1){
					$(this).children("img").css({"transition" : "all 0s ease 0s;", "transform" : "none", "opacity" : 1});
					$(this).find(".desc").css({"display" : "none"});
				}
			}, function(){
				var img_box = $(this).find(".desc");
				img_box.fadeOut().stop().animate({ "opacity": 0 }, 500);
				$.when(img_box).then();
			});
		}
	});	
	

	var elem = jQuery(".path_sub .path>li");
	var depNav = jQuery(".dep_nav");
	var thIs = jQuery(this);
	elem.each(function(){
		jQuery(".path>li>.more, .path .dep_nav").hover(function(){
			//jQuery(".path>li>.more").addClass("on");
			jQuery(depNav, this).show();
		},function(){
			//jQuery(".path>li>.more").removeClass("on");
			jQuery(depNav, this).hide();
		});
	});

	/*var favo = jQuery(".btn_order_wrap .btn_favorite");
	favo.click(function(){
		if(!favo.hasClass("on")){
			jQuery(this).addClass("on");
		}else{
			jQuery(this).removeClass("on");
		}
		return false;
	});  */

	var select_box = jQuery(".sele_box");
	var opt = jQuery(".option_list");
	var optList = jQuery(".option_list ul li");
	select_box.click(function(e){
		if(opt.css("display")=="none"){
			opt.stop().fadeIn(200);
			select_box.addClass("on");
		}else{
			opt.stop().fadeOut(200);
			select_box.removeClass("on");
		}
		e.preventDefault();
	});
	optList.each(function(){
		optList.click(function(){
			opt.hide();
			jQuery(this).addClass("on").siblings().removeClass("on");
			var textval =jQuery(this).text();
			select_box.text(textval.replace("옵션을 선택하세요.", textval)).removeClass("on");
			return false;
		});
	});
	
	// 스크롤 값에 의한 좌측 메뉴 고정 수정
	var navSide = jQuery(".nav_side_wrap");
	var nav = jQuery(".nav_section");
	if(navSide.length && nav.length ) {
		var offset = navSide.offset();
		var offpos = offset.top - 50;
		//nav.html( "left: " + offset.left + ", top: " + offset.top ); //left:322.5 top:628
		var windoWidth = jQuery(window).width();
		jQuery(window).scroll(function(){
			var navPos = jQuery(this).scrollTop();
			if(offpos < navPos) {
				navSide.addClass("active");
			} else {
				navSide.removeClass("active");
			}
		});
		// 2022-02-03 목요일 추가
		jQuery(window).on('resize orientationchange', function() {
			offset = navSide.offset();
			offpos = offset.top - 50;
		});
	}

 	jQuery("ul.clearfix img").error(function() {
 		if (jQuery(this).hasClass('off')) {
 			jQuery(this).siblings().attr('class', 'off active');
 		}
 		jQuery(this).remove();
 	});

 	//효율코드 추가
	var LSEQ_DATA = {
		"category" : "419538"
	};

	//카테고리 효율코드 호출
	$('nav.shop_gnb').click(function(e){
        var currentUrl = document.location.href;
        if(currentUrl.indexOf('grand') < 0){
            GsBase.recordWiselog({"lseq":LSEQ_DATA["category"]});
        }
	});
	
	
});